<template>
    <div>
        <geometry-element
                selectable
                movable
                resizable
                :connectable="!isReadOnly"
                :deletable="!isReadOnly"
                :id.sync="value.elementView.id"
                :x.sync="value.elementView.x"
                :y.sync="value.elementView.y"
                :width.sync="value.elementView.width"
                :height.sync="value.elementView.height"
                :angle.sync="value.elementView.angle"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:rotateShape="onRotateShape"
                v-on:labelChanged="onLabelChanged"
                v-on:addedToGroup="onAddedToGroup"
                v-on:dblclick="showWorkflowPanel"
                v-on:removeShape="beforeRemove(value); onRemoveShape(value)"
                :label.sync="name"
                :_style="{
                'label-angle':value.elementView.angle,
                'font-weight': 'bold','font-size': '16'
                }">

            <geometry-rect
                    :_style="{
                        'fill-r': 1,
                        'fill-cx': .1,
                        'fill-cy': .1,
                        'stroke-width': 1.4,
                        'stroke': '#98cbff',
                        fill: '#98cbff',
                        'fill-opacity': 1,
                        r: '1'
                    }"
            ></geometry-rect>
            
            <sub-elements>
                <!--title-->
                <text-element
                        :sub-width="'100%'"
                        :sub-height="25"
                        :sub-top="5"
                        :text="value.name">
                </text-element>
            </sub-elements>
            <!-- <k8s-sub-controller
                    v-for="(connectableType, index) in filterConnectionTypes"
                    :key="index"
                    :element="value"
                    :image="connectableType.src"
                    :type="connectableType.component">
            </k8s-sub-controller> -->
        </geometry-element>

    </div>
</template>

<script>
    import Element from "../KubernetesElement";

    export default {
        mixins: [Element],
        name: 'workflowDag',
        components: {},
        props: {},
        computed: {
            imgSrc() {
                return `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/argo/argo-icon-color.svg`
            },
            className() {
                return 'WorkflowDag'
            },
            createNew(elementId, x, y, width, height, object) {
                return {
                    _type: this.className(),
                    name: '',
                    parentId: '',
                    elementView: {
                        '_type': this.className(),
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({}),
                        'angle': 0,
                    },
                    object: object ? object: {
                        "name": "",
                        "template": "",
                        "arguments": {
                            "parameters": []
                        }
                    },
                    index: null,
                    connectableType: [ "WorkflowDag" ],
                }
            },
            name() {
                try {
                    return this.value.object.name;
                } catch (e) {
                    return "Untitled";
                }
            },
        },
        data: function () {
            return {};
        },
        created: function () {
            var me = this;
            if(me.value.parentId.length < 1) {
                var designer = this.getComponent('kubernetes-model-canvas');
                var compInfo = {
                    'component': "workflow",
                    'label': "Workflow",
                    'src': `${window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/argo/argo-icon-color.svg`,
                    'x': me.value.elementView.x+240,
                    'y': me.value.elementView.y
                }
                let el = designer.addElement(compInfo);
                me.refresh();
                me.value.parentId = el.elementView.id;
                me.value.parentElName = el.object.metadata.name;
                me.value.index = (el.tasks).length;
                me.value.name = "task";
                me.value.object.name = "Task1";
                el.workflowType = "dag";
                el.tasks.push(me.value);
                el.object.spec.templates[0].dag.tasks.push(me.value.object);
                
                me.value.elementView.x = me.value.elementView.x + 1
                me.$nextTick(function () {
                    me.value.elementView.x = me.value.elementView.x - 1
                })
            }
        },
        mounted: function () {
            var me = this;
            me.refresh();

            me.$EventBus.$on(`${me.value.elementView.id}`, function (obj) {
                if(obj.action=="addRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "WorkflowDag"
                    && obj.element.targetElement.elementView.id == me.value.elementView.id) {
                    if(obj.element.targetElement.object.dependencies == undefined) {
                        obj.element.targetElement.object.dependencies = [];
                        obj.element.targetElement.object.dependencies.push(obj.element.sourceElement.object.name);
                    }
                    obj.element.targetElement.object.dependencies.forEach(name => {
                        if(name == obj.element.sourceElement.object.name) {
                            return;
                        } else {
                            obj.element.targetElement.object.dependencies.push(obj.element.sourceElement.object.name);
                        }
                    });
                    var item = {
                        action: "updateDag",
                        element: obj.element.targetElement
                    };
                    me.$EventBus.$emit(`${me.value.parentId}`, item);
                }
                if(obj.action=="deleteRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "WorkflowDag"
                    && obj.element.targetElement.elementView.id == me.value.elementView.id) {
                    me.value.object.dependencies.splice(me.value.object.dependencies.indexOf(obj.element.sourceElement.object.name), 1);
                    console.log(me.value.object);
                }
            });
        },
        watch: {
        },
        methods: {
            deSelectedActivity: function () {
                var me = this;
                if (me.value) {
                    me.selected = false
                    me.openPanel = false
                    
                    var designer = me.getComponent('kubernetes-model-canvas')
                    designer.deSelected(me.value.object)

                    var obj = {
                        action: "closeProperty",
                        element: me.value
                    };
                    me.$EventBus.$emit(`${me.value.parentId}`, obj);
                }
            },
            beforeRemove(value) {
                var me = this;
                var obj = {
                    action: "deleteDag",
                    element: value
                }
                me.$EventBus.$emit(`${me.value.parentId}`, obj);
            },
            showWorkflowPanel() {
                var me = this;
                var obj = {
                    action: "showProperty",
                    element: me.value
                };
                me.$EventBus.$emit(`${me.value.parentId}`, obj);
            }
        },
    }
</script>

<style>

</style>